import { MessageService } from './message.service';
import { Injectable } from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class ConfirmInputService {
  constructor(private messageService: MessageService) {}

  private inputConfirmed: boolean = false;

  changeInputStatus(inputStatus: boolean) {
    this.inputConfirmed = inputStatus;
  }

  async waitUserInput() {
    while (this.inputConfirmed === false) await this.messageService.timeout(50);
    this.inputConfirmed = false;
  }
}
